document.addEventListener("DOMContentLoaded", async () => {
  const { disableContextImage } = await import("../components/detect-image.js");
  disableContextImage('.js-context-image');
});
